$(function () {
    $('.alert__item .js-alert__close').click(function (e) {
        e.preventDefault();
        var $this = $(this);
        var alertDiv = $this.closest('.alert__item');
        var newGuid = alertDiv.attr('data-id');
        if (getCookie("dismissedAlerts").length > 0) {
            var existingCookieValue = getCookie("dismissedAlerts");
            var existingGuids = existingCookieValue.split("|");
            if (existingGuids.indexOf(newGuid) < 0) {
                existingGuids.push(newGuid);
            }
            setCookie("dismissedAlerts", existingGuids.join("|"), 360)
        } else {
            setCookie("dismissedAlerts", newGuid, 360)
        }
        alertDiv.addClass("-hidden");
    });
});